"use client";

import { useState, useEffect } from "react";
import { AdminsTable } from "@/components/admins-table";
import { useAdmins } from "@/hooks/use-admins";

export default function AdminsPage() {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce search query
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPageIndex(0); // Reset to first page on search
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Fetch admins with pagination
  const { data, isLoading, error } = useAdmins({
    pageNumber: pageIndex + 1, // API uses 1-based page numbers
    pageSize: pageSize,
    search: debouncedSearch || undefined,
  });

  return (
    <div className="flex flex-1 flex-col">
      <div className="flex flex-1 flex-col gap-4 p-4 md:gap-6 md:p-6">
        {/* Page Header */}
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Admins</h1>
          <p className="text-muted-foreground">
            Manage and view all your admins
          </p>
        </div>

        {/* Admins Table */}
        <AdminsTable
          data={data?.data || []}
          isLoading={isLoading}
          error={error ? String(error) : null}
          totalCount={data?.count || 0}
          pageIndex={pageIndex}
          pageSize={pageSize}
          searchQuery={searchQuery}
          onPageChange={setPageIndex}
          onPageSizeChange={setPageSize}
          onSearchChange={setSearchQuery}
        />
      </div>
    </div>
  );
}
